import { IApplicationState } from '../../../../types/types';
import { TSnackbarId } from '../store/types';
import { snackbarTopSelector } from './snackbarTopSelector';

export const snackbarTopIdRenderedSelector = (
    state: IApplicationState
): TSnackbarId => {
    const snackbar = snackbarTopSelector(state);
    return state.snackbarsStack.isSuspended
        ? undefined
        : snackbar ? snackbar.id : undefined;
}
